import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <h6 className='text-center'><img src="https://media.istockphoto.com/id/1459824813/vector/health-care-medical-icon-design.jpg?s=612x612&w=0&k=20&c=oJfp94KWM1HJZcykISWWG1W99JiSpeki4gmjIqs44yI=" style={{ width: 100 }} alt="" /></h6>
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>League Name</span>
                            <p>League A</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Country</span>
                            <p>Country A</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>No of Teams:</span>
                            <p>6</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Season Start Date:</span>
                            <p>2024-03-01</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Season End Date:</span>
                            <p>2024-03-04</p>
                        </div>

                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Website:</span>
                            <p>
                                <a href="https://media.istockphoto.com/">https://media.istockphoto.com/</a>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Contact Email:</span>
                            <p>User@mail.com</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Contact Phone:</span>
                            <p>12345678900</p>
                        </div>
                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Description:</span>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing
                                elit. Accusamus recusandae fugiat sit quas in amet dignissimos illum aliquid </p>
                        </div>

                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Added By</span>
                            <p>
                                <span class="badge bg-warning">
                                    User 1
                                </span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated By</span>
                            <p>
                                <span class="badge bg-warning">
                                    User 1
                                </span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Created At</span>
                            <p>
                                <span class="badge bg-info">
                                    2024-03-02T09:45:00
                                </span>
                            </p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated At</span>
                            <p>
                                <span class="badge bg-info">
                                    2024-03-02T09:45:00
                                </span>
                            </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;